export default __webpack_public_path__ + "static/media/Group 1899.746c1c0e.svg";